<template>
    <div class="park">
        <Title chineseTitle="园区概况" englishTitle="Park profile">
        </Title>
        <div class="parkContent">
            <div class="body">
                <div class="progressContainer">
                    <div class="progressTitle">负荷率</div>
                    <div class="progress">
                        <CircleProgress
                            :value="($store.state.MQTTObj[deviceName + 'P'] / ($store.state.receivingCapacity * 500) ).toFixed(2)" />
                    </div>
                    <div class="progressValue">
                        {{($store.state.MQTTObj[deviceName + 'P'] / ($store.state.receivingCapacity * 5)).toFixed(2) + "%"}}
                    </div>
                    <div class="progressText">{{'受电容量: ' + $store.state.receivingCapacity + 'kVA'}}</div>
                </div>
            </div>
            <div class="body">
                <Item title="总负荷"
                    :data="$store.state.MQTTObj[deviceName + 'P'] ? $store.state.MQTTObj[deviceName + 'P'] / 1000 : 0"
                    unit="kVA" />
            </div>
            <div class="body">
                <Item title="变压器容量" data="--" unit="" />
            </div>
            <div class="body">
                <Item title="年用电量" :data="p_total" unit="kWh" />
            </div>
            <div class="body">
                <Item title="功率因数"
                    :data="$store.state.MQTTObj[deviceName + 'PF'] ? $store.state.MQTTObj[deviceName + 'PF'] : 0"
                    :icon="icon()" />
            </div>
            <div class="body">
                <div class="errorContainer">
                    <div class="errorDataContainer">
                        <div class="errorName">在线</div>
                        <div class="errorData">4</div>
                    </div>
                    <div class="errorDataContainer">
                        <div class="errorName">离线</div>
                        <div class="errorData">0</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Title from "@/components/Title.vue";
    import Item from "@/components/Item";
    import CircleProgress from "@/components/CircleProgress";
    import {
        GetCurrentPowerInfo,
    } from "@/components/Request";

    export default {
        name: "ParkOverView",
        components: {
            Title,
            Item,
            CircleProgress,
        },
        props: ["projectId"],
        data() {
            return {
                p_total: 0,
                timer: null,
                deviceName: this.$store.getters.getOverViewDeviceName(this.projectId),
            };
        },
        created() {
            this.getCurrentPowerInfo()
        },
        mounted() {
            this.timer = (() => {
                this.getCurrentPowerInfo()
            }, 1000 * 60 * 30)
        },
        beforeDestroy() {
            this.timer && clearInterval(timer)
            this.timer && (this.timer = null)
        },
        methods: {
            getCurrentPowerInfo() {
                GetCurrentPowerInfo({
                    projectId: this.projectId
                }).then(({
                    data
                }) => {
                    this.p_total = data.data.result.total
                })
            },

            icon() {
                if (!this.$store.state.MQTTObj[this.deviceName + "PF"]) {
                    return "差";
                } else if (this.$store.state.MQTTObj[this.deviceName + "PF"] > 0.9) {
                    return "优";
                } else if (this.$store.state.MQTTObj[this.deviceName + "PF"] > 0.5) {
                    return "良";
                } else {
                    return "差";
                }
            },
        },
    };
</script>

<style lang="less" scoped>
    .progressContainer {
        width: 1960/192vw;
        height: 1500/108vh;
        background: #030d18;
        opacity: 0.75;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
    }

    .progressTitle {
        font-size: 18px;
        font-weight: 400;
        color: #e6f8ff;
        opacity: 0.7;
    }

    .progress {
        width: 1200/192vw;
        height: 640/108vh;
        background: #030d18;
    }

    .progressValue {
        margin-top: -30px;
        font-size: 24px;
        font-weight: bold;
        color: #ffffff;
    }

    .progressText {
        font-size: 14px;
        font-weight: 400;
        color: #e6f3fd;
        opacity: 0.7;
    }

    .park {
        position: fixed;
        top: 880/108vh;
        left: 160/192vw;
    }

    .siteBody {
        height: 100px;
        background: #030d18;
        opacity: 0.75;
    }

    .parkContent {
        margin-left: 112/192vw;
        width: 4080/192vw;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }

    .body {
        margin-left: 80/192vw;
        margin-top: 80/108vh;
        overflow: hidden;

        .errorContainer {
            width: 1960/192vw;
            height: 1500/108vh;
            background: #030d18;
            opacity: 0.75;
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            align-items: center;
        }

        .errorDataContainer {
            width: 1200/192vw;
            display: flex;
            flex-direction: row;
            align-items: baseline;
            justify-content: space-between;

            .errorName {
                font-size: 18px;
                color: #e6f8ff;
                opacity: 0.7;
            }

            .errorData {
                font-size: 30px;
                color: #fff
            }
        }
    }
</style>